<template>
  <div>
    <vs-button
      color="primary"
      class="go-previous"
      v-bind:class="[{'d-none': fullscreen}]"
      v-on:click="$parent.goBack($route.path === '/searchroute' || $route.path === '/route' || $route.path === '/landmarkpoi' || $route.path === '/place' || $route.path === '/bustrip')"
      style="width: 48px; height: 48px;"
    >
      <img
        class="menu"
        :src="$parent.icon.back_alt_icon"
        style="width:25px; margin: 0 1px 2px 0;"
      >
    </vs-button>
    <div
      id="map"
      ref="MapContentBox"
    ></div>

    <!-- Traffic button -->
    <button
      class="btn-traffic position-absolute"
      style="right: 11px; top: 230px; z-index: 10;"
      :class="[{'d-none': fullscreen}]"
      :style="{'top' : ($parent.isDesktop() ? '230px' : ($route.path === '/' ? '120px' : '72px'))}"
      @click="switchTraffic"
    >
      <img
        height="34"
        :src="showTraffic ? icon.traffic_on : icon.traffic_off"
        class="position-relative"
      >
    </button>

    <!-- Places (Restaurants, Bus Stop, Hospital, Hotel) -->
    <PlaceTagButtons
      v-if="$route.path == '/' && !fullscreen"
      :class="[{'d-none': fullscreen, 'place-tag-buttons-desktop': $parent.is_desktop }]"
      @on-tag-toggle="onTagToggle"
    />

    <div
      class="zoom-box-container position-absolute"
      ref="ZoomBox"
      :class="[{'zoom-box-guide': !$parent.is_desktop && $route.path === '/searchroute'}]"
    >
      <div
        class="zoom-box position-absolute"
        :class="[{'d-none': fullscreen}]"
      >
        <div
          class="go-current cursor"
          :class="{'go-current-rotate' : isLoadingLocation}"
          @click="goCurrent"
        >
          <img
            :src="(isLoadingLocation || !!$parent.currentLocation) ? icon.current_icon : icon.current_no_gps_icon"
            style="width: 34px;"
          >
        </div>
        <vs-divider color="#ebebeb" class="m-0 px-1"></vs-divider>
        <div
          class="zoom-out cursor"
          @click="zoomOut"
        >
          <img
            :src="icon.zoomout_icon"
            style="width: 34px;"
          >
        </div>
        <vs-divider color="#ebebeb" class="m-0 px-1"></vs-divider>
        <div
          class="zoom-in cursor"
          @click="zoomIn"
        >
          <img
            :src="icon.zoomin_icon"
            style="width: 34px;"
          >
        </div>
      </div>
      <LatestNews
        v-if="!$parent.isDesktop() && !$parent.isHideMap"
        :isDesktop="$parent.isDesktop()"
        :class="[{'d-none': $parent.map_fullscreen}]"
      />
    </div>
  </div>
</template>

<script>
import LatestNews from '@/components/LatestNews';
import PlaceTagButtons from '@/components/PlaceTagButtons';
export default {
  name: 'Map',
  components: {
    LatestNews,
    PlaceTagButtons
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      icon: {
        traffic_off: require('@/assets/icon/ic_traffic_off.svg'),
        traffic_on: require('@/assets/icon/ic_traffic_on.svg'),
        current_icon: require('@/assets/icon/ic_current.svg'),
        current_no_gps_icon: require('@/assets/icon/ic_current_no_gps.svg'),
        zoomin_icon: require('@/assets/icon/ic_zoomin.svg'),
        zoomout_icon: require('@/assets/icon/ic_zoomout.svg'),
      },
      isLoadingLocation: false,
      showTraffic: false,
      eventBinded: false
    };
  },
  mounted () {
    this.showTraffic = (this.$parent.config.map == longdo.Layers.TRAFFIC.name())
  },
  methods: {
    onTagToggle (tag) {
      const scope = this.$parent
      if (tag.name === '__namtang_tc') {
        if (tag.active) {
          this.getTcStops()
          scope.map.zoom(10, true)
        } else {
          // remove tc stops
          scope.map.Overlays.list().forEach(pin => {
            if (pin.tc_station) scope.map.Overlays.remove(pin)
          })
        }
        return //
      }
      if (tag.active) {
        scope.map.Tags.add(tag.name, {
          icon: {
            urlHD: scope.api_url + tag.pinImageUrlHD,
            offset: scope.getPinOffset('tag', tag.largePinIcon)
          },
        })
      } else {
        scope.map.Tags.remove(tag.name)
      }
      scope.map.Tags.enablePopup(false)
    },
    switchTraffic () {
      this.showTraffic = !this.showTraffic
      const map = this.$parent.map
      if (this.showTraffic) {
        map.Layers.add(longdo.Layers.TRAFFIC)
        // map.Overlays.load(longdo.Overlays.cameras)
        // map.Overlays.load(longdo.Overlays.events)
      } else {
        map.Layers.remove(longdo.Layers.TRAFFIC)
        map.Overlays.unload(longdo.Overlays.cameras)
        map.Overlays.unload(longdo.Overlays.events)
      }
      this.saveTrafficConfig(this.showTraffic)
    },
    async saveTrafficConfig (showTraffic) {
      this.$parent.config.map = showTraffic ? window.longdo.Layers.TRAFFIC.name() : window.longdo.Layers.LIGHT_POI.name()
      // save config (online)
      if (this.$parent.is_login) {
        // WS-115
        var url = process.env.API_URL + '/front/user/config/save'
        const data = { 'config': JSON.stringify(this.$parent.config) }

        const apiResult = await this.Api.Call({
          method: 'POST',
          path: url,
          data: data,
        });

        if (apiResult.code === 200 && apiResult.data) {
          console.log('config successfully.')
        } else {
          console.log('config failed.')
        }
      }
      // save config (offline)
      localStorage.setItem('settings', JSON.stringify(this.$parent.config))
    },
    goCurrent () {
      const scope = this
      const map = scope.$parent.map
      if (!scope.eventBinded) {
        scope.eventBinded = true
        map.Event.bind('geolocation', function (position) {
          scope.$parent.currentLocation = { lon: position.coords.longitude, lat: position.coords.latitude }
          scope.isLoadingLocation = false
        })
        map.Event.bind('geolocationError', function () {
          scope.isLoadingLocation = false
        })
      }

      map.Overlays.list().forEach(pin => {
        if (pin.element() != null && pin.element().src == longdo.MapTheme.ui.geolocationMarkerIcon.urlHD) {
          map.Overlays.remove(pin)
        }
      })
      map.location(longdo.LocationMode.Geolocation)
      scope.isLoadingLocation = true
    },
    zoomIn () {
      this.$parent.map.zoom(true)
    },
    zoomOut () {
      this.$parent.map.zoom(false)
    },
    //
    drawUnselectedMarker (item) {
      const scope = this
      var offset = scope.$parent.getPinOffset(item.pinImageUrlHD, !!(item.largePinIcon))
      var marker = new longdo.Marker(item.location, {
        title: item.name,
        icon: {
          urlHD: scope.$parent.api_url + item.pinImageUrlHD,
          offset: offset
        },
        clickable: true
      })

      marker.station = JSON.stringify(item)
      marker.tc_station = true
      scope.$parent.map.Overlays.add(marker)
    },
    pinTcStop(items) {
      let scope = this

      if (items.length > 0) {
        items.forEach(function(item) {
          scope.drawUnselectedMarker(item)
        })
      }
    },
    // WS-???
    getTcStops() {
      let scope = this
      const url = `${process.env.API_URL}/front/tc-stops?locale=${scope.$parent.getUILanguage()}`
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.code === 200) {
            scope.pinTcStop(response.data.data)
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
  }
};
</script>

<style lang="scss" scoped>
.zoom-box-container {
  right: 11px;
  bottom: 192px;
  z-index: 10;
  &.zoom-box-guide {
    right: 13px;
    bottom: 37px !important;
  }
}

.zoom-box {
  width: 46px;
  box-shadow: 0px 0px 7.4px 0px rgba(39, 39, 39, 0.19);
  border-radius: 8px;
  background: white;
  top: -140px;
  right: 0;
}

.btn-traffic {
  width: 46px;
  height: 46px;
  box-shadow: 0px 0px 7.4px 0px rgba(39, 39, 39, 0.19);
  border: none;
  border-radius: 8px;
  background: white;
  display: block;
}

.go-previous {
  position: fixed;
  z-index: 10;
  left: 12px;
  top: 10px !important;
}
</style>
